import useCurrentHcs from '../../../hooks/useCurrentHcs'
import PlannedConsultationCardList from '../plannedConsultationCardList/PlannedConsultationCardList'
import { PlannedConsultationMainProps } from './_props'

const PlannedConsultationMain = ({ isPreview = false }: PlannedConsultationMainProps) => {
    const healthCareService = useCurrentHcs()

    return (
        <div key={healthCareService.id}>
            <PlannedConsultationCardList isPreview={isPreview} />
        </div>
    )
}

export default PlannedConsultationMain
